import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { Col, Row, Card, Spinner, Button } from 'reactstrap';
import { BsFillBarChartFill } from 'react-icons/bs';
import useDataSuiteWidgets from './Widgets/useDataSuiteWidgets';
import { slideDrawer } from '../../reducers/UIReducer/UIActions';
import useDataSuite from './useDataSuite';
import { useState } from 'react';
import { Theme } from '../../config/constants';
import ExportSlideDrawer from '../../sharedComponents/SlideDrawer/ExportSlideDrawer';
import getWelcomeName from '../../sharedComponents/WelcomeName/getWelcomeName';
import FiltersWidget from '../../sharedComponents/Filters/FiltersWidget';
import moment from 'moment';

const DataSuiteDetails = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { fromDate, toDate, updateWidgetContent, setReturningFromDetails } = useDataSuite.useDataSuite();
  const detailsPageLoading =  useSelector(({datasuite}) => datasuite.isLoading.detailsPageLoading);
  const [detailsContent, setDetailsContent] = useState(<div>No data to display.</div>);
  const [exportFilters, setExportFilters] = useState({});
  const widgetDetailsData = useSelector(({datasuite}) => datasuite.widgetDetailsData);
  const competitiveInsightsWidget = useDataSuiteWidgets.useCompetitiveInsightsWidget();
  const growthOpportunitiesWidget = useDataSuiteWidgets.useGrowthOpportunityWidget();
  const leakageWidget = useDataSuiteWidgets.useLeakageWidget();
  const lostLocationsWidget = useDataSuiteWidgets.useLostLocationsWidget();
  const newLocationsWidget = useDataSuiteWidgets.useNewLocationsWidget();
  const opportunitiesByStoreWidget = useDataSuiteWidgets.useOpportunityByStoreWidget();
  const salesByCategoryWidget = useDataSuiteWidgets.useSalesByCategoryWidget();
  const salesByOperatorWidget = useDataSuiteWidgets.useSalesByOperatorWidget();
  const salesVoidOpportunityWidget = useDataSuiteWidgets.useSalesVoidOpportunityWidget();
  const targetsByCategoryWidget = useDataSuiteWidgets.useTargetsByCategoryWidget();
  const topProductsWidget = useDataSuiteWidgets.useTopProductsWidget();
  const topCategoriesWidget = useDataSuiteWidgets.useTopCategoriesWidget();
  const segmentWidget = useDataSuiteWidgets.useSegmentOverviewWidget();
  const prechosenFilters = location.state?.selectedFilters ?? {};
  var widgetName = location.search.replaceAll('?', '').replaceAll('%20', ' ');
  var mfrName = getWelcomeName() || 'Admin';
  const dateRanges = {
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'Last 2 Months': [moment().subtract(2, 'month'), moment()],
    'Last Year': [moment().subtract(1, 'year'), moment()]
  };

  const closeSlideDrawer = () => {
    dispatch(slideDrawer.subtractDatasuiteDetails());
  }

  const getWidgetContent = () => {
      switch (widgetName) {
      case ("Competitive Insights") : {
        setDetailsContent(competitiveInsightsWidget.detailsContent());
        break;
      }
      case ("Growth Opportunities") : {
        setDetailsContent(growthOpportunitiesWidget.detailsContent());
        break;
      }
      case ("Leakage") : {
        setDetailsContent(leakageWidget.detailsContent());
        break;
      }
      case ("Lost Locations") : {
        setDetailsContent(lostLocationsWidget.detailsContent());
        break;
      }
      case ("New Locations") : {
        setDetailsContent(newLocationsWidget.detailsContent());
        break;
      }
      case ("Opportunities By Store") : {
        setDetailsContent(opportunitiesByStoreWidget.detailsContent());
        break;
      }
      case ("Sales By Category") : {
        setDetailsContent(salesByCategoryWidget.detailsContent());
        break;
      }
      case ("Sales By Operator") : {
        setDetailsContent(salesByOperatorWidget.detailsContent());
        break;
      }
      case ("Sales Void Opportunities") : {
        setDetailsContent(salesVoidOpportunityWidget.detailsContent());
        break;
      }
      case ("Targets By Category") : {
        setDetailsContent(targetsByCategoryWidget.detailsContent());
        break;
      }
      case ("Top Products") : {
        setDetailsContent(topProductsWidget.detailsContent());
        break;
      }
      case ("Top Categories") : {
        setDetailsContent(topCategoriesWidget.detailsContent());
        break;
      }
      case ("Segment Overview"): {
        setDetailsContent(segmentWidget.detailsContent());
        break;
      }
      default : {
        // Do nothing
      }
    }
  };

  const onClickWidgetName = () => {
    navigate(-1);
    setReturningFromDetails(true);
  };

  const getWidgetData = (selectedFilters) => {
    setExportFilters(selectedFilters);
    updateWidgetContent(widgetName, selectedFilters);
  };

  useEffect(() => {
    closeSlideDrawer();
    getWidgetData(prechosenFilters);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    //eslint-disable-next-line
  }, []);

  // eslint-disable-next-line
  useEffect(() => {getWidgetContent();}, [widgetDetailsData]);

  return (
    <Col className='px-3 py-3'>
      <Col className='d-flex justify-content-between align-items-end' >
        <div className='main-header text-size-32 ' style={{fontWeight: '700', letterSpacing:'.0025em', lineHeight: '38px'}}>
          <BsFillBarChartFill
              className='me-1'
              style={{
                verticalAlign: 'middle',
                marginBottom: '8px',
                fill: 'url(#icon-gradient)' 
              }}
            />
          SalesStream
        </div>    
        <svg width= '26px' height='26px' style={{position: 'absolute'}}>
          <linearGradient id="icon-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop stopColor={Theme().colors.gradientColorTwo} offset="0%" />
            <stop stopColor={Theme().colors.gradientColorOne} offset="100%" />
          </linearGradient>
        </svg>
        <div className='main-header text-size-20 align-self-end' style={{lineHeight:'23px', fontWeight:'700',letterSpacing:'.0025em' }}>{mfrName}</div>
      </Col>
      <div className='main-header text-size-20 align-self-end' style={{lineHeight:'23px', fontWeight:'400',letterSpacing:'.0025em' }}>{widgetName} Details</div>
      <hr className='line' style={{border: '1px solid grey'}}></hr>
      <Row className='mx-0 flex align-items-center'>
            <Col className="px-1 pb-2 w-fc">
                <div className="main-header text-size-16 clickable" style={{color: Theme().colors.accent}} onClick={() => onClickWidgetName()}>{widgetName}</div>
            </Col>
            <Col className="px-1 pb-2 w-fc">
                <div className="main-header text-size-20">&#62;</div>
            </Col>
            <Col className="px-1 pb-2">
                <div className="main-header text-size-16">View Details</div>
            </Col>
            <Col className='w-fc pb-2 ml-auto'>
                <Button 
                    block 
                    className='py-1 button-label' 
                    size='sm' 
                    style={{width: '80px'}}
                    color={Theme().colors.accentName}
                    onClick={() => dispatch(slideDrawer.addExport())}>Export
                </Button>
            </Col>
        </Row>
      <Row className='px-0' id="dataSuiteDetailsFiltersCard">
        <FiltersWidget
            minDate={fromDate}
            fromDate={fromDate}
            toDate={toDate}
            dateRanges={dateRanges}
            onApplyFilters={getWidgetData}
            datasetOptionsEnabled={true}
            prechosenFilters={prechosenFilters}
            saveFilterSetsEnabled={false}
            filterSetOptionsEnabled={false}
        />
      </Row>
      <Row className='mx-0' style={{height: '76vh'}}>
        <Card style={{padding: '0px 0px'}}>
          {detailsPageLoading && 
          <Row className='h-100 w-100 mx-auto' style={{background:'white', borderRadius: '5px'}}>
            <Col className='mx-auto my-auto' style={{width:"2.5%"}}>
              <Spinner animation="border" color='beplBlue' style={{marginLeft: '50%'}}/>
            </Col>
          </Row>
          }
          {!detailsPageLoading && detailsContent &&
          <Row className='h-100 w-100 mx-0 px-0'>
            {detailsContent}
          </Row>
          }
        </Card>
      </Row>
      <ExportSlideDrawer title={widgetName} className="exportSlideDrawer" drawerContents={""} prechosenFilters={exportFilters}/>
    </Col>
  )
}

export default DataSuiteDetails;
